module.exports = __webpack_public_path__ + "static/media/hero.413c098e.png";